import React from 'react';
import { useParams, Link } from 'react-router-dom';
import helpConfig from '../../content/help/config.json';
import { HelpConfig } from '../../types/Help';

const config = helpConfig as HelpConfig;

export default function HelpCategory() {
  const { categoryId } = useParams<{ categoryId: string }>();

  if (!categoryId) {
    return <div>Invalid category</div>;
  }

  const category = config.categories.find((cat) => cat.id === categoryId);
  if (!category) {
    return <div>Category not found</div>;
  }

  document.title = `${category.title} | Wilma Help`;

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      {/* Breadcrumb */}
      <nav className="mb-6 text-sm text-gray-600">
        <Link to="/help" className="hover:text-wilma-600">
          Help
        </Link>
        <span className="mx-2">/</span>
        <span className="text-wilma-600">{category.title}</span>
      </nav>

      {/* Category Title */}
      <h1 className="text-3xl font-bold mb-2 text-wilma-600">{category.title}</h1>
      {category.description && (
        <p className="text-gray-600 mb-8">{category.description}</p>
      )}

      {/* Pages List */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {category.pages.map((page) => (
          <Link
            key={page.id}
            to={`/help/${categoryId}/${page.id}`}
            className="block p-6 border border-gray-200 rounded-lg hover:border-wilma-600 hover:shadow-md transition-shadow"
          >
            <h2 className="text-xl font-semibold mb-2 text-wilma-600">{page.title}</h2>
            {page.scribeId && (
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-wilma-100 text-wilma-600">
                Video Tutorial Available
              </span>
            )}
          </Link>
        ))}
      </div>
    </div>
  );
}

